export default "__VITE_PUBLIC_ASSET__eb79ce70__"